import './App.css';
import { Fragment } from 'react';
import Routes from './routes/routes';
import { UserProvider } from './context/userContext';
import { ChatbotProvider } from './context/chatbotContext';
import { GenericDataProvider } from './context/genericDataContext';
import { MetaProvider } from './context/metaContext';
import { IntegrationProvider } from './context/integrationContext';
import { CallAnalysisProvider } from './context/callAnalysisContext';
import { CalendlyProvider } from './context/calendlyIntegrationContext';
import { LeadIntegrationProvider } from './context/leadIntegrationContext';
import { MessageFormatProvider } from './context/messageFormatContext';
import { WhatsappCampaignProvider } from './context/whatsappCampaignContext';
import { ContactProvider } from './context/contactContext';
import { FlowBuilderDataProvider } from './context/flowBuilderContext';
import { WorkflowProvider } from "./context/workflowContext";
import { ReactFlowProvider } from '@xyflow/react';
import { DataConnectorProvider } from './context/dataConnectorContext';
import { WhatsappTemplateProvider } from './context/whatsappTemplateContext';
function App() {
  return (
    <Fragment>
      <ReactFlowProvider>
        <FlowBuilderDataProvider>
          <WorkflowProvider>
            <CalendlyProvider>
              <CallAnalysisProvider>
                <WhatsappTemplateProvider>
                  <WhatsappCampaignProvider>
                    <ContactProvider>
                      <MessageFormatProvider>
                        <LeadIntegrationProvider>
                          <IntegrationProvider>
                            <MetaProvider>
                              <GenericDataProvider>
                                <DataConnectorProvider>
                                  <ChatbotProvider>
                                    <UserProvider>
                                      <Routes />
                                    </UserProvider>
                                  </ChatbotProvider>
                                </DataConnectorProvider>
                              </GenericDataProvider>
                            </MetaProvider>
                          </IntegrationProvider>
                        </LeadIntegrationProvider>
                      </MessageFormatProvider>
                    </ContactProvider>
                  </WhatsappCampaignProvider>
                </WhatsappTemplateProvider>
              </CallAnalysisProvider>
            </CalendlyProvider>
          </WorkflowProvider>
        </FlowBuilderDataProvider>
      </ReactFlowProvider>
    </Fragment>
  );
}

export default App;
